import React, { useState } from 'react';
import { Button, Drawer, PageHeader, Space, notification } from 'antd';

import AdminTable from '../containers/AdminTable';
import EditAdminForm from '../containers/EditAdminForm';
import { useDeleteAdminMutation, useGetAdminsQuery } from '../../../app/api/adminApiSlice';
import Admin from '../../../core/models/Admin';

const ListAdmins: React.FC = () => {
  const [editDrawerVisible, setEditDrawerVisible] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const { data: admins, isLoading } = useGetAdminsQuery();
  const [deleteAdmin, { isLoading: isDeleteInProgress, isError, error }] = useDeleteAdminMutation();

  const [selectedAdmin, setSelectedAdmin] = useState<Admin | undefined>(undefined);

  return (
    <>
      <PageHeader
        className='site-page-header'
        title='Admin Users'
        extra={[
          <Button
            key='1'
            type='primary'
            onClick={() => {
              setSelectedAdmin(undefined);
              setEditDrawerVisible(true);
            }}
          >
            Add
          </Button>,
        ]}
      />
      <AdminTable
        admins={admins}
        isLoading={isLoading}
        onEdit={(admin: Admin) => {
          setSelectedAdmin(admin);
          setEditDrawerVisible(true);
        }}
        onDelete={(admin: Admin) => {
          console.log('Delete admin', admin);
          deleteAdmin(admin.id)
            .unwrap()
            .then(() => {
              notification.success({
                message: 'Success',
                description: 'Account deleted successfully',
              });
            })
            .catch((error) => {
              console.log(error);
            });
        }}
      />
      <Drawer
        title='Add/Edit Admins'
        width={600}
        onClose={() => setEditDrawerVisible(false)}
        open={editDrawerVisible}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose={true}
        extra={
          <Space>
            <Button onClick={() => setEditDrawerVisible(false)}>Cancel</Button>
            <Button
              type='primary'
              form='editAdminForm'
              key='submit'
              htmlType='submit'
              loading={isSaving}
            >
              Submit
            </Button>
          </Space>
        }
      >
        <EditAdminForm
          admin={selectedAdmin}
          handleIsLoading={(saving: boolean) => setIsSaving(saving)}
          onSuccessfulSubmit={() => setEditDrawerVisible(false)}
        />
      </Drawer>
    </>
  );
};

export default ListAdmins;
